export const CHECKED_IN = 'CHECKED-IN';
export const REQUESTED = 'REQUESTED';
export const REQUESTING = 'REQUESTING';
export const MISSED = 'MISSED';
